<script lang="ts">
	import { page } from '$app/state';
	import Container from '$lib/Container.svelte';

	import error404 from '$lib/assets/404.svg';
</script>

<svelte:head>
	<title>{page.error?.message}</title>
</svelte:head>

<Container wrapperClass="page-py" class="grid md:grid-cols-2">
	<img class="mx-auto mb-8 md:mb-0" src={error404} alt="404" />
	<div class="text-center md:text-left">
		<h1 class="mb-8 font-serif text-4xl font-medium">
			Let’s try again to get our beansprout growing.
		</h1>
		<p>{page.error?.message}</p>
		<br />
		<p class="mb-2">Here are some helpful links instead:</p>
		<ul>
			<li>
				<a class="link" href="/">Home</a>
			</li>
			<li>
				<a class="link" href="/insights">Insights</a>
			</li>
		</ul>
	</div>
</Container>
